module.exports = __webpack_public_path__ + "afa7dbc432ac2862b3828ce44d5e7cad.fbx";